import classNames from 'classnames'
import React from 'react'
import s from '../../fields.scss'
import {ErrorProps} from './index'

export const Error = ({dataHook, className, error}: ErrorProps) =>
  error ? (
    <div data-hook={dataHook} className={classNames(s.error, className)} role="alert" aria-live="assertive">
      {error}
    </div>
  ) : null
